import { ReactNode } from 'react'
import { Button, ButtonProps } from 'antd'
import { ButtonSetsType } from '../ActionBarDisplay'
import IconGlobalApp from '../../../../../utils/IconGlobalApp'
import { mapCommonIcons } from '../../../../../utils/mapCommonIcons'

type IProps = {
  customText?: ReactNode
} & ButtonProps

/**
 * Generates dropdown style for the delete button.
 * @returns An object containing the dropdown items props.
 */
export const deleteBtnDropDownStyle = (): ButtonSetsType['collapseProps'] => ({
  key: 'delete',
  label: 'Xóa',
  danger: true,
  icon: <IconGlobalApp name={mapCommonIcons.delete} />,
})

const DeleteButton = ({ customText, ...props }: IProps) => (
  <Button
    type="text"
    danger
    icon={<IconGlobalApp name={mapCommonIcons.delete} />}
    {...props}
  >
    {customText ?? 'Xóa'}
  </Button>
)

export default DeleteButton
